module.exports = __webpack_public_path__ + "img/about-promo.35077c1a.png";